export default "__VITE_ASSET__DFH_onTs__"